import React from "react";
import Form from "@components/shared/form";
import Image from "next/legacy/image";
import { GQLCategories, GQLUrls } from "@gql/types/gql";
import styles from "./style.module.scss";
import {
    addNoFollowToLinks,
    PLACE_HOLDER_IMAGE_PATH,
    resolveURL,
} from "@lib/sharedUtils";
// import blogImgPlaceholder from "@public/placeHolder844x538.png";
import { selectedCategoryAtom } from "@store/formStore";
import { useAtom } from "jotai";
import { SelectedCategory } from "@genericTypes/form-store-types";
import { titleDecoder } from "@lib/sharedUtils";
import { useQuery } from "@tanstack/react-query";
import Share from "../share/Share";
import ListOfContentsMobile from "../listOfContentsMobile";
import { Session } from "src/api/session";
import FormFusion from "@components/shared/formFusion";

export default function Introduction({
    category,
    listOfContentsMobile,
}: {
    category: GQLCategories;
    listOfContentsMobile: { title: string | null; link: string }[];
}) {
    const [, setSelectedCategory] = useAtom(selectedCategoryAtom);
    const session = useQuery<Session>({ queryKey: ["session"] });
    const { data: formFusionForm } = useQuery({
        queryKey: ["formFusionForm"],
    });

    setSelectedCategory(category as SelectedCategory);
    const categoryImage: string | undefined =
        (category?.mainImage?.fullPath as string) ??
        (category?.image?.fullPath as string) ??
        undefined;
    return (
        <section
            className={`${styles["borderStyle"]} pb-12`}
            itemScope
            itemType="https://schema.org/Article"
        >
            <h1
                id="about"
                itemProp="name"
                className={`${styles["textColor"]}  font-extrabold lg:text-2xl text-xl leading-8 lg:leading-[45px]`}
            >
                {titleDecoder(
                    (category?.subtitle ??
                        category?.headline ??
                        category?.label ??
                        category?.name) as string,
                    {
                        category: category?.label ?? category?.name ?? "",
                        region: session?.data?.visitDetails?.region ?? "",
                    },
                )}
            </h1>
            <Share
                contentToBeSharedUrl={resolveURL(category?.url as GQLUrls)}
                secondStyle
            />
            <div className={`lg:mt-4 mt-6 ${styles.mainCategoryImage}`}>
                {categoryImage ? (
                    <div className={`relative w-full ${styles.mainImage}`}>
                        <Image
                            src={categoryImage}
                            alt={
                                (category?.label as string) ??
                                (category?.name as string)
                            }
                            width={844}
                            height={538}
                            itemProp="image"
                            priority
                            className="block w-full"
                            sizes="(max-width: 768px) 100vw,
                            (max-width: 1200px) 50vw,
                            60vw"
                        />
                    </div>
                ) : (
                    <>
                        <img
                            src={PLACE_HOLDER_IMAGE_PATH}
                            width={844}
                            height={538}
                            alt={
                                (category?.label as string) ??
                                (category?.name as string) ??
                                "category image"
                            }
                        />
                    </>
                )}
            </div>
            {category?.overview ? (
                <div itemProp="description">
                    <div
                        className={`${styles["paragraphColor"]}  lg:text-lg text-sm lg:leading-8 leading-6 mt-8 `}
                        dangerouslySetInnerHTML={{
                            __html: addNoFollowToLinks(category?.overview),
                        }}
                    />
                </div>
            ) : (
                <></>
            )}
            {listOfContentsMobile?.length > 0 && (
                <ListOfContentsMobile contents={listOfContentsMobile} />
            )}
            {formFusionForm ? (
                <FormFusion category={category} />
            ) : (
                <Form shouldSplit={true} />
            )}

            {/* <FromFusion /> */}

            <div
                className={`${styles["paragraphColor"]}  lg:text-lg text-sm lg:leading-8 leading-6 lg:mt-8 mt-6 `}
                id="description"
                itemProp="articleBody"
                dangerouslySetInnerHTML={{
                    __html: addNoFollowToLinks(category?.description as string),
                }}
            />
        </section>
    );
}
